import PageHero from '@/components/feature/PageHero';
import { parkingProductsHero } from '@/mocks/parkingProducts';

export default function Hero() {
  return (
    <PageHero
      eyebrow={parkingProductsHero.eyebrow}
      title={parkingProductsHero.title}
      titleHighlight={parkingProductsHero.titleHighlight}
      subtitle={parkingProductsHero.subtitle}
      desc={parkingProductsHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Clean%20minimal%20smart%20city%20technology%20concept%20with%20connected%20camera%20sensor%20and%20terminal%20devices%20arranged%20in%20a%20modular%20grid%2C%20deep%20navy%20ink%20background%2C%20eco%20green%20and%20gold%20accent%20highlights%2C%20futuristic%20digital%20infrastructure%20aesthetic%2C%20cinematic%20soft%20lighting&width=1800&height=1200&seq=products-hero-01&orientation=landscape&nocache=true"
      imageAlt="华辉数智 智慧城市产品 智能视觉监控与物联感知终端"
      imageTitle="华辉数智 智慧城市产品"
    />
  );
}